export const ADDTOCART = "cart/addtocart";
export const INCREMENT = "cart/increment";
export const DECREMENT = "cart/decrement";
export const TOTALITEM = "cart/totalitem";
export const TOTALPRICE = "cart/totalprice";
